<template>
  <TvaModal :show="show" @onClose="$emit('onClose')">
    <div class="strategy-modal">
      <TextTitle class="strategy-modal__title" :title="title" modal />

      <div class="strategy-modal__content">
        <div class="strategy-modal__content__top">
          <p
            v-for="paragraph of paragraphsWithImages"
            :key="paragraph.slice(0, 10)"
            v-html="paragraph"
          />
        </div>

        <TextBlock class="strategy-modal__content__bottom" v-bind="bottom" />

        <div class="strategy-modal__content__images">
          <img
            v-for="index in 18"
            :key="'goal-' + index"
            :src="`${$baseUrl}images/SDGs/goal-${index}.webp`"
            class="strategy-modal__content__images__image"
          />
        </div>
      </div>
    </div>
  </TvaModal>
</template>

<script setup>
import { inject, computed } from "vue";

import TvaModal from "../../general/TvaModal.vue";
import TextTitle from "../../general/TextTitle.vue";
import TextBlock from "../../general/TextBlock.vue";

const props = defineProps({
  show: Boolean,
  title: String,
  bottom: Object,
  paragraphs: {
    type: Array,
    default: () => [],
  },
  content: Object,
});

const $baseUrl = inject("$baseUrl");

const paragraphsWithImages = computed(() =>
  props.paragraphs.map((p) => {
    return p
      .replaceAll("<", `<img alt='' src='${$baseUrl}images/SDGs/goal-nr-`)
      .replaceAll(">", `.svg' />`);
  })
);
</script>

<style lang="scss" scoped>
.strategy-modal {
  display: flex;
  padding: 0 var(--page-padding-h);
  width: 100vw;
  height: calc(var(--vh) * 100);
  background-color: var(--white-100);

  .mobile &,
  .tablet & {
    flex-direction: column;
  }

  &__title {
    flex-shrink: 0;
    padding: 5vh var(--modal-padding) 0 0;

    .desktop &,
    .large & {
      border-right: 1px solid var(--scala-grigi-gray-3);
    }

    .mobile &,
    .tablet & {
      padding: 4rem 0 3vh;
      border-bottom: 1px solid var(--scala-grigi-gray-3);
    }
  }

  &__content {
    padding: 5vh 1rem 0 var(--modal-padding);
    height: 100%;
    max-height: calc(var(--vh) * 100);
    overflow: auto;

    &__top {
      .mobile &,
      .tablet & {
        @include p-s;
      }

      ::v-deep(img) {
        width: 1.5rem;
        transform: translateY(10%);

        .mobile &,
        .tablet & {
          width: 1.25rem;
        }
      }
    }

    &__bottom {
      padding: 0 !important;
      padding-top: 4vh !important;

      ::v-deep(.text-title) {
        @include dida-m;

        padding-bottom: 0;
      }

      ::v-deep(.text-block__paragraph) {
        @include p-xs;
        line-height: 19.07px;
        margin-top: toRem(12);

        .mobile &,
        .tablet & {
          @include p-s;
        }
      }
    }

    &__images {
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 17px;
      grid-row-gap: 12px;
      width: 100%;
      margin-top: toRem(20);
      margin-bottom: 2rem;

      &__image {
        max-width: 100%;
        height: auto;
      }

      .mobile &,
      .tablet & {
        grid-template-columns: repeat(6, 1fr);
        grid-template-rows: repeat(3, 1fr);
        grid-column-gap: 8px;
        grid-row-gap: 8px;
        padding-bottom: toRem(20);
      }
    }
  }

  // .mobile &,
  // .tablet & {
  //   &__content {
  //     // flex-direction: column;
  //     // overflow: auto;
  //     // padding: 0;

  //     > :first-child {
  //       width: 100%;
  //       padding: var(--page-padding-h);
  //     }

  //     > :last-child {
  //       width: 100%;
  //     }
  //   }
  // }
}
</style>
